module.exports = __webpack_public_path__ + "static/katja_schneidereit-9e5b0992c42f8cbe7028498c40895db0.jpg";